import type { IWarehouseRepository } from '../../domain/interfaces';
import { WarehouseEntity } from '../../domain/entities/Warehouse';
import type { CreateWarehouseDTO } from '../dtos/warehouse/CreateWarehouseDTO';
import type { WarehouseResponseDTO } from '../dtos/warehouse/WarehouseResponseDTO';

export interface CreateWarehouseUseCase {
  execute(dto: CreateWarehouseDTO): Promise<WarehouseResponseDTO>;
}

export default class CreateWarehouseUseCaseImpl implements CreateWarehouseUseCase {
  constructor(
    private readonly warehouseRepository: IWarehouseRepository
  ) {}

  async execute(dto: CreateWarehouseDTO): Promise<WarehouseResponseDTO> {
    if (!dto.name || dto.name.trim().length === 0) {
      throw new Error('Warehouse name is required');
    }

    const warehouse = WarehouseEntity.create({
      name: dto.name.trim(),
      status: 'ACTIVE',
    });

    await this.warehouseRepository.save(warehouse);

    return {
      id: warehouse._id,
      name: warehouse.name,
      status: warehouse.status,
      createdAt: warehouse.createdAt,
      updatedAt: warehouse.updatedAt,
    };
  }
}
